module.exports = __webpack_public_path__ + "static/haveX86.168a10ad.png";